import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import { usePlantContext } from "../../../../../../../components/Drawers/TreeViewDrawer/PlantContext";

export default function VendorBidEvaluationPage() {
  const { bidId } = useParams();
  const { plant } = usePlantContext();

  return (
    <Box>
      <PageHeader plant={plant} pageTitle="Vendor Bid Evaluation" />
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {bidId ? `Bid for MRQ #${bidId}` : "Coming soon..."}
        </Typography>
      </Box>
    </Box>
  );
}
